import React, { type ReactNode } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { fireOperationalAnalytics, MountEvent } from '@atlassian/jira-product-analytics-bridge';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createSubscriber, createContainer, createHook } from '@atlassian/react-sweet-state';
import * as actions from '../actions/index.tsx';
import Store, { type Actions } from '../store.tsx';
import { type FetchingState, FetchingStates, type State, type ContainerProps } from '../types.tsx';

export const AssetTypesSubscriber = createSubscriber<State, Actions>(Store, {
	displayName: 'AssetTypesSubscriber',
});

export type Props = {
	baseUrl: string;
	children: ReactNode;
};

const AssetTypesContainerWithoutAnalytics = createContainer<State, Actions, ContainerProps>(Store, {
	onInit:
		() =>
		({ dispatch }) =>
			dispatch(actions.fetch({})),
});

const fireAnalyticsEvent = (
	analyticsEvent: UIAnalyticsEvent,
	fetchingState: FetchingState,
	error?: Error,
) => {
	if (fetchingState === FetchingStates.FAILED) {
		fireOperationalAnalytics(analyticsEvent, 'fetchAssetTypes Failed', {
			error,
		});
	} else {
		fireOperationalAnalytics(analyticsEvent, 'fetchAssetTypes Succeeded');
	}
};

export const AssetTypesContainer = (props: Props) => (
	<AssetTypesContainerWithoutAnalytics baseUrl={props.baseUrl}>
		<AssetTypesSubscriber>
			{({ fetchingState, error }) =>
				fetchingState !== FetchingStates.INIT && fetchingState !== FetchingStates.LOADING ? (
					<MountEvent
						// eslint-disable-next-line jira/react-no-inline-function-prop
						onMount={(analyticsEvent) => fireAnalyticsEvent(analyticsEvent, fetchingState, error)}
					/>
				) : null
			}
		</AssetTypesSubscriber>
		{props.children}
	</AssetTypesContainerWithoutAnalytics>
);

export const useAssetTypes = createHook(Store);
